import axios from '@/utils/request'

/**
 * 在线保修列表
 */
export const getRepairList = (params, options) => axios({
  url: '/base/repair',
  params,
  options
})

/**
 * 在线保修回复
 */
export const putReply = (data) => axios({
  url: '/base/repair/reply',
  method: 'put',
  data
})

/**
 * 在线保修完成
 */
export const finshRepair = (uuid) => axios({
  url: `/base/repair/status/${uuid}`,
  method: 'put',
})

/**
 * 投诉建议列表
 */
export const getFeedBackList = (params, options) => axios({
  url: '/base/feedback',
  params,
  options
})

/**
 * 投诉建议已读
 */
export const finshFeedBack = (uuid) => axios({
  url: `/base/feedback/read/${uuid}`,
  method: 'put',
})